import { getLandingClusterByDisplayId } from '../../utils/landingClusterUtils';

const migrations = {
  // Changes all clusterId values in landing to be displayId and save clusterId with a real value
  0: (state) => {
    const { displayId, id: clusterId } =
      getLandingClusterByDisplayId(state.landing.clusterId) || {};

    return {
      ...state,
      landing: {
        ...state.landing,
        displayId: displayId || null,
        clusterId: clusterId || null,
      },
    };
  },
  // delete appInstallationId
  1: (state) => {
    const newState = { ...state };
    delete newState.app.appInstallationId;
    return newState;
  },
};

export default migrations;
